import React from 'react';
import { GerenciarAtendimentosSse } from './GerenciarAtendimentosSse';
import { VerMapa } from './VerMapa';
import { useApp } from '../../../../context/app';
import GaleriaImagens from "./GaleriaImagens";

export const AtendimentosSse = () => {
  const { renderIncludeScreen, manageItem } = useApp();

  if (manageItem.type === 'GALERIA') {
    return <GaleriaImagens />
  }
  return renderIncludeScreen ?  <VerMapa />  :  <GerenciarAtendimentosSse />;
};
